import { render, staticRenderFns } from "./ReportingOverview.vue?vue&type=template&id=20275d6a&scoped=true&"
import script from "./ReportingOverview.vue?vue&type=script&lang=js&"
export * from "./ReportingOverview.vue?vue&type=script&lang=js&"
import style0 from "./ReportingOverview.vue?vue&type=style&index=0&id=20275d6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20275d6a",
  null
  
)

export default component.exports